import React from 'react';
import './MenuIcons.scss';

interface MenuIconProps {
    src: string;
    alt: string;
    isActive?: boolean;
    isHovered?: boolean;
    isSubMenuOpen?: boolean;
    isSubMenuHovered?: boolean;
}

const MenuIcon: React.FC<MenuIconProps> = ({
    src,
    alt,
    isActive = false,
    isHovered = false,
    isSubMenuOpen = false,
    isSubMenuHovered = false
}) => {
    // Class name'leri daha temiz bir şekilde oluştur
    const getClassName = () => {
        let classes = ['menu-icon'];

        if (isActive) {
            classes.push('menu-icon--active');
        } else if (isSubMenuOpen) {
            classes.push('sub-menu-icon--active');
        }

        if (isHovered || isSubMenuHovered) {
            classes.push('menu-icon--hovered');
        }

        return classes.join(' ');
    };

    return (
        <img
            src={src}
            alt={alt}
            className={getClassName()}
        />
    );
};

export default MenuIcon;